// routes/generator.agent.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/generator.agent')

export const handle = { name: 'generator/agent' }

export default dynamic(getClientModule, { ssr: false })
